module.exports = __webpack_public_path__ + "img/avatar_default.e11b93a0.png";